import { FunctionComponent, PropsWithChildren, useContext } from "react";
import Logo from "../logo";
import Button from "../button";
import { supabase } from "libs/supabase";
import { LoadingContext } from "providers/loading";
import { useLocation, useNavigate } from "react-router-dom";
import { useId } from "react-id-generator";
import classNames from "classnames";

interface DashboardProps extends PropsWithChildren {
  links: { label: string; path: string; testId: string; isSelected?: (path: string) => boolean }[];
}

const Dashboard: FunctionComponent<DashboardProps> = ({ children, links }) => {
  const { setLoading } = useContext(LoadingContext);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const ids = useId(links.length);

  return (
    <div className="fixed inset-0 flex">
      <div className="w-[226px] flex-shrink-0 border-r flex flex-col justify-between">
        <div>
          <div className="h-[64px] flex items-center px-5 border-b mb-4">
            <Logo />
          </div>
          <div></div>
          {links.map((link, i) => (
            <div
              data-testid={link.testId}
              key={ids[i]}
              onClick={() => navigate(link.path)}
              className={classNames(
                "py-3 px-5 cursor-pointer select-none",
                (link.isSelected ? link.isSelected(pathname) : pathname === link.path)
                  ? "bg-gradient-to-r from-main-from to-main-to text-white"
                  : "hover:bg-black/5 active:bg-black/10"
              )}
            >
              {link.label}
            </div>
          ))}
        </div>
        <div className="p-5 w-full">
          <Button
            onClick={async () => {
              setLoading(true);
              await supabase.auth.signOut();
              setLoading(false);
              navigate("/");
            }}
            variant="secondary"
            className="w-full"
          >
            Logout
          </Button>
        </div>
      </div>
      <div className="flex-grow overflow-auto">{children}</div>
    </div>
  );
};

export default Dashboard;
